import { render, staticRenderFns } from "./option.vue?vue&type=template&id=3bdfc760&scoped=true"
import script from "./option.vue?vue&type=script&lang=js"
export * from "./option.vue?vue&type=script&lang=js"
import style0 from "./option.vue?vue&type=style&index=0&id=3bdfc760&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdfc760",
  null
  
)

export default component.exports